module Tapas.ViewModels {    

    export class OrderTemplatePageViewModel extends Tapas.ViewModels.CartViewModel {        
        
        public OrderTemplateDataService = new Ftw.Dataservice.OrderTemplateDataservice();
        public OrderTemplateList = ko.observableArray([]);
        public OrderTemplateListElement = ko.observable<HTMLElement>();
        public OrderTemplateName = ko.observable('');
        public OrderTemplateId = ko.observable('');        
        public Saved = ko.observable('');
        public OrderTemplateStatus = ko.observable('');
        public OrderTemplateEdit = ko.observable(false);
        constructor() {
            super();
        }          
        public GetProductViemodelsFromDom(): Array<ProductViewModel> {
            //Get all the elements that the productviewmodel is bound to
            var $items = $(this.OrderTemplateListElement()).children();
            var result = [];
            $items.each((i, elm) => {                                
                var productViewModel: ProductViewModel = ko.dataFor(elm);                                                
                result.push(productViewModel);                             
            });            
            return result;   
        }     
        public AddAllToCart() {
            var all = this.GetProductViemodelsFromDom();
            if (all.length < 1) return;
            this.CartLoading(true);
            var addToCartArgs = new Array<Ftw.Dataservice.ICartAddArgs>();
                        
            $.each(all, ((i, vm: ProductViewModel) => {
                var orderLineFields = new Array<Ftw.Dataservice.ICartAddOrderLineField>();
                var orderLineField = <Ftw.Dataservice.ICartAddOrderLineField>{
                    systemName: 'Comment',
                    value: vm.Comment()
                };
                orderLineFields.push(orderLineField);
                var addToCartObj = <Ftw.Dataservice.ICartAddArgs>{
                    productId: vm.ProductId(),
                    quantity: vm.Quantity(),
                    variantId: vm.VariantId(),
                    orderLineFields: orderLineFields                    
                };
                addToCartArgs.push(addToCartObj);                
            }));
            this.CartDataService.AddMultipleProducts(addToCartArgs).then((result) => {

            }).finally(() => {
                this.CartLoading(false);
            });
        } 
        public SaveAll() {
            var all = this.GetProductViemodelsFromDom();
            if (all.length < 1) return;
            var otName = this.OrderTemplateName();
            var otId = '';
            var lines = new Array<Ftw.Dataservice.ISaveOrderTemplateLine>();
             
            $.each(all, ((i, vm: ProductViewModel) => {
                otId = vm.OrderTemplateViewModel.OrderTemplateId();
                var line: Ftw.Dataservice.ISaveOrderTemplateLine = {
                    otlid : vm.OrderTemplateViewModel.OrderTemplateLineId(),
                    comment : vm.Comment(),
                    productId : vm.ProductId(),
                    quantity : vm.Quantity()
                };
                lines.push(line);

            }));
            this.OrderTemplateDataService.SaveOrderTemplate(otName, otId, lines).then((result) => {
                this.Saved('success');                
            });
        }      

        public SaveName() {
            var all = this.GetProductViemodelsFromDom();
            if (all.length < 1) return;
            var otName = this.OrderTemplateName();
            
            this.OrderTemplateDataService.SaveOrderTemplate(otName, this.OrderTemplateId()).then((result) => {                
                this.OrderTemplateEdit(false);
            });
        }

        public ConfirmDelete = () => {
            this.OrderTemplateStatus('confirmation');
        }
        public Delete() {
            this.OrderTemplateDataService.DeleteOrderTemplate(this.OrderTemplateId()).then((result) => {                
            });                
        }
    }
}